<div class="login-page">
  <form class="login-card" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <!-- Brand -->
    <div class="brand">
      <picture>
        <source srcset="../../assets/logo_sm.jpg" media="(min-width: 300px) and (max-width: 576px)">
        <source srcset="../../assets/logo.jpg" media="(min-width: 576px)">
        <img src="../../assets/logo.jpg" alt="Labrador AI" class="brand-logo">
      </picture>
    </div>

    <h1 class="heading">Forgot password?</h1>
    <p class="subheading" *ngIf="!submitted">Enter your work email and we'll send you a reset link.</p>

    <!-- Email entry state -->
    <ng-container *ngIf="!submitted">
      <div class="field">
        <label for="email" class="field-label">Work email</label>
        <input id="email" type="text" formControlName="email" class="field-input"
          [ngClass]="{ 'is-invalid': error && f.email.errors }" placeholder="you@restaurant.com"
          autocomplete="username">
      </div>

      <div *ngIf="error" class="alert">Invalid email</div>

      <button type="submit" class="btn-primary" [disabled]="loading">
        <span *ngIf="!loading">Send reset link</span>
        <span *ngIf="loading">Sending…</span>
      </button>
    </ng-container>

    <!-- Confirmation state -->
    <div *ngIf="submitted" class="confirm-message">
      <p>We've emailed you instructions for setting your password, if an account exists with the email you entered. You should receive them shortly.</p>
      <p>If you don't receive an email, please make sure you've entered the address you registered with, and check your spam folder.</p>
    </div>

    <p class="back-hint">
      <a [routerLink]="['/login']">&#8592; Back to sign in</a>
    </p>
  </form>
</div>
